import React, {useState} from 'react';
import {connect} from 'react-redux';
import SelectList from "app/Components/Shared/SelectList/SelectList";
import BtnSubmit from "app/Components/Shared/Buttons/BtnSubmit";
import {
  setSubscriber,
  simReplacementInit,
} from "app/Components/Block/SimReplacementBlock/simReplacementSlice";

const SelectSubscriber = (props) => {
  const [error, setError] = useState(null);
  const {
    subscribers,
    subscriber,
  } = props.simReplacementState;
  const {setSubscriber, simReplacementInit} = props;

  const handleSelectSubscriber = (e) => {
    setSubscriber(e);
  }

  const onSubmit = async () => {
    setError(null)
    if (!subscriber) {
      setError("עליך לבחור מנוי כדי להמשיך")
    } else {
      simReplacementInit();
    }
  }

  return (
    <>
      <div className={'select-subscriber-container'}>
        <div className={'title-container'}>
          <span className={'title'}>
            איזה כיף!<br/>
  יש לכם כמה מנויי סלולר
          </span>
          <span className="subtitle">
    באיזה מנוי תרצו לבצע את הפעולה?
            </span>
        </div>
        <SelectList
          options={subscribers.map((subscriber) => {
            return {
              key: subscriber.slice(0, 3) + '-' + subscriber.slice(3),
              value: subscriber,
            }
          })}
          onClick={(e) => handleSelectSubscriber(e)}
          hideRadioButtons={true}
        />
      </div>
      <div className={'bottom-container'}>
        <span className={'error'}>{error}</span>
        <BtnSubmit text={'המשך'} onclick={onSubmit}/>
      </div>
    </>
  )
    ;
};

const mapStateToProps = (state) => {
  return {
    simReplacementState: state.SimReplacement,
  };
};

const mapDispatchToProps = {
  setSubscriber,
  simReplacementInit
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectSubscriber);
